import { createFileRoute } from '@tanstack/react-router';
import { ObjectOverview } from '@/pages/workspaces/objects/object-detail/object-overview';
import { withRoutePageRendered } from '@/services/rum/use-route-page-rendered';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/')({
  component: withRoutePageRendered(ObjectOverview),
});
